module.exports = __webpack_public_path__ + "static/img/culture_04.6b9c37f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investCenter/culture_04.png
// module id = qE2s
// module chunks = 0